import { render, staticRenderFns } from "./BannerPrincipal2.vue?vue&type=template&id=35e4d669&lang=pug&"
import script from "./BannerPrincipal2.vue?vue&type=script&lang=js&"
export * from "./BannerPrincipal2.vue?vue&type=script&lang=js&"
import style0 from "./BannerPrincipal2.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports